import { render, staticRenderFns } from "./coinList.vue?vue&type=template&id=64270e63&scoped=true&"
import script from "./coinList.vue?vue&type=script&lang=js&"
export * from "./coinList.vue?vue&type=script&lang=js&"
import style0 from "./coinList.vue?vue&type=style&index=0&id=64270e63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64270e63",
  null
  
)

export default component.exports